
<div class="open-app" v-show="show">
  <div class="close" @click="show = !show">
    <img src="@/assets/student/closeX.png" alt="" />
  </div>
  <div class="logo">
    <img src="@/assets/usercenter/parentHandbook/logo.png" alt="" />
  </div>
  <div class="desc">{{ $t("src_components_openApp_index_e86a4c6a") }}</div>
  <div class="open" @click="openApp('h5', path)">
    <span>{{ $t("src_components_openApp_index_f3dda5c6") }}</span>
  </div>
</div>
